export default __webpack_public_path__ + "static/media/logo.0414cbaf.png";